import React from 'react';

import classnames from 'classnames';

import { Icon } from '../../../../Icon/Icon';
import { useSelectRootContext } from '../../root/SelectRootContext';

import styles from './SelectArrow.module.scss';

export const SelectArrow = () => {
    const { open, disabled } = useSelectRootContext();
    return (
        <span
            className={classnames(styles.arrow, {
                [styles.open]: open,
                [styles.disabled]: disabled
            })}
            aria-hidden="true"
        >
            <Icon name="s-icon-arrow-chevron-down" className={styles.icon} />
        </span>
    );
};
